import * as type from './mutation-types'
export const state = {
    status: -9999,
    errmsg: '',
    changeState: {},
    changing: 'changing',
    sendState: {},
    sending: 'sending',
    checkState: {},
    checking: 'checking',
    pOrderList: {},
    loadingP: 'loadingP',
    rOrderList: {},
    loadingR: 'loadingR',
    relateReturn: {},
    relateStatus: 'stating',
    updateReturn: {},
    updateStatus: 'stating',
    awReturn: {},
    awStatus: 'stating',
    inheritData: {},
    inheStatus: 'stating',
    logCode: {},
    lcLoading: '',
    whiteList: {},
    wlLoading: '',
}
export const mutations = {
    [type.ERROR_RECEIVE](state, res) {},
    [type.CHECKWHITELIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.whiteList = {}
        state.wlLoading = 'loading'
    },
    [type.CHECKWHITELIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.whiteList = (res && res.content) || {}
        state.wlLoading = state.status > -9999 && 'loaded'
    },
    [type.GETLOGCODE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.logCode = {}
        state.lcLoading = 'loading'
    },
    [type.GETLOGCODE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.logCode = (res && res.content) || {}
        state.lcLoading = state.status > -9999 && 'loaded'
    },
    [type.CHANGEPWD_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.changeState = {}
        state.changing = 'changing'
    },
    [type.CHANGEPWD_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.changeState = (res && res.content) || {}
        state.changing = state.status > -9999 && 'changed'
    },
    [type.INHERIT_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.inheritData = {}
        state.inheStatus = 'stating'
    },
    [type.INHERIT_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.inheritData = (res && res.content) || {}
        state.inheStatus = state.status > -9999 && 'stated'
    },
    [type.SENDEMAILCODE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.sendState = {}
        state.sending = 'sending'
    },
    [type.SENDEMAILCODE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.sendState = (res && res.content) || {}
        state.sending = state.status > -9999 && 'sended'
    },
    [type.CHECKEMAILCODE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.checkState = {}
        state.checking = 'checking'
    },
    [type.CHECKEMAILCODE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.checkState = (res && res.content) || {}
        state.checking = state.status > -9999 && 'checked'
    },
    [type.GETPORDERLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pOrderList = {}
        state.loadingP = 'loadingP'
    },
    [type.GETPORDERLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pOrderList = (res && res.content) || {}
        state.loadingP = state.status > -9999 && 'loadedP'
    },
    [type.GETRORDERLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.rOrderList = {}
        state.loadingR = 'loadingR'
    },
    [type.GETRORDERLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.rOrderList = (res && res.content) || {}
        state.loadingR = state.status > -9999 && 'loadedR'
    },
    [type.RELATEEMAIL_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.relateReturn = {}
        state.relateStatus = 'stating'
    },
    [type.RELATEEMAIL_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.relateReturn = (res && res.content) || {}
        state.relateStatus = state.status > -9999 && 'stated'
    },
    [type.UPGRADEEMAIL_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.updateReturn = {}
        state.updateStatus = 'stating'
    },
    [type.UPGRADEEMAIL_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.updateReturn = (res && res.content) || {}
        state.updateStatus = state.status > -9999 && 'stated'
    },
    [type.INTAWARD_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.awReturn = {}
        state.awStatus = 'stating'
    },
    [type.INTAWARD_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.awReturn = (res && res.content) || {}
        state.awStatus = state.status > -9999 && 'stated'
    }
}